import { useScrollProgress } from '../hooks/useScrollProgress';

function ScrollProgress() {
  const { progress } = useScrollProgress();

  return (
    <div
      className="fixed top-0 left-0 right-0 h-[3px] z-[90] bg-gradient-to-r from-signal to-signal-light shadow-[0_0_18px_rgba(46,179,231,0.55)] origin-left"
      style={{ transform: `scaleX(${progress})` }}
      aria-hidden="true"
    />
  );
}

export default ScrollProgress;
